import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=2b086f5d&scoped=true"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./RadioButtonGroup.vue?vue&type=style&index=0&id=2b086f5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b086f5d",
  null
  
)

export default component.exports